import { trackEvent, trackSelect } from "../../lib/utils/analytics";
import useGameStore from "../../lib/store/GameStore";
import { useT } from "../../i18n/LocaleContext";

export function HowToPlayLink() {
  const t = useT();
  const [setIsOpen] = useGameStore((state) => [state.setIsHelpOpen]);

  function openModal() {
    setIsOpen(true);
    trackEvent("how_to_play_button");
    trackSelect({
      contentType: "button",
      itemId: "how_to_play",
    });
  }

  return (
    <button onClick={openModal} className="hover:underline">
      {t("footer.howToPlay")}
    </button>
  );
}
